import React from 'react';
import { Box, Divider as MuiDivider } from '@mui/material';

interface DividerProps {
  value: {
    orientation: 'horizontal' | 'vertical';
    variant: 'fullWidth' | 'inset' | 'middle';
    width: string[];
    height: string[];
    thickness: string[];
    spacing: string[];
    color: string;
  };
}

const Divider = ({ value }: DividerProps) => {
  if (!value) return null;

  return (
    <Box
      component={MuiDivider}
      orientation={value.orientation ?? 'horizontal'}
      variant={value.variant ?? 'fullWidth'}
        sx={{
            width: value.width ?? '100%',            
            my: value.spacing ?? ['unset'],
            // backgroundColor: value.color,
        }}      
    />
  );
};

export default Divider;
